import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SubscriptionPagesAndFootersSettings = lazy(() =>
  import("@scenes/EmailSettings/SubscriptionPagesAndFootersSettings").then((module) => ({
    default: module.SubscriptionPagesAndFootersSettings,
  }))
);

export const subscriptionPagesAndFootersNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("subscription-pages-and-footers-nro-heading", "Subscription Pages and Footers"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return !featureOn("disable_custom_unsubscribe_and_preference_center_pages_in_ui");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  Component: SubscriptionPagesAndFootersSettings,
  componentFeatureFlippers: ["subscription_pages_and_footers_nro_component", "email_preferences_nro_component"],
};
